import { useState, useEffect } from "react";
import FootballAPI from "../api/football.api";

function useTeamStandings(competitionId) {
  const [isLoadingStandings, setIsLoadingStandings] = useState(true);
  const [standings, setStandings] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await FootballAPI.getStandings(competitionId);

      setStandings(result);
      setIsLoadingStandings(false);
    };

    fetchData();
  }, [competitionId]);

  return {
    isLoadingStandings,
    standings,
  };
}

export default useTeamStandings;
